import { UserDto } from '../dto/user.dto';
import { OrderFilter } from '../../interfaces/filters/order.filter';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { Transform } from 'class-transformer';
import {
	stringToBoolean,
	stringToBooleanNullable,
	stringToNumber,
} from '../../types-transformers/boolean-transformers';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';
import { jsonStringToObject } from '../../types-transformers/order-transformers';
import { AccountsPrivacyOptionsEnum } from '../../enums/accounts-privacy-options.enum';
import { GendersEnum, CommunityProfileAdminsEnum } from '../../enums';
import { arrayOrStringToArray } from '../../types-transformers';

export class UserFilter implements OrderFilter<UserDto>, PaginationFilter {
	@Transform(stringToBoolean)
	public includeRelationsWithCurrentUserFlags?: boolean;

	@Transform(stringToBoolean)
	public includeConnectionsCalculation?: boolean;

	@Transform(stringToBoolean)
	public includeMemberships?: boolean;

	@Transform(stringToBoolean)
	public includeChallenges?: boolean;

	@Transform(stringToBoolean)
	public withSoftDeleted?: boolean;

	@Transform(stringToBoolean)
	public suggestedUsers?: boolean;

	@Transform(stringToBooleanNullable)
	public isBusinessProfile?: boolean;

	@Transform(stringToBooleanNullable)
	public isCommunityProfile?: boolean;

	@Transform(stringToBooleanNullable)
	public includeGlobalCommunities?: boolean;

	@Transform(stringToBoolean)
	public excludeFollowings?: boolean;

	@Transform(stringToBoolean)
	public onlySubscriptions?: boolean;

	@Transform(stringToBoolean)
	public includeAdmins?: boolean;

	@Transform(stringToBoolean)
	public includeFiles?: boolean;

	@Transform(stringToBoolean)
	public orderedBySweatHeroPlaces?: boolean;

	@Transform(stringToBoolean)
	public hasEmail?: boolean;

	@Transform(stringToBooleanNullable)
	public isRecommendedCommunityProfile?: boolean;

	@Transform(stringToBooleanNullable)
	public isReadyToSweatMatch?: boolean;

	@Transform(stringToBooleanNullable)
	public discoverCommunityProfiles?: boolean;

	@Transform(stringToBooleanNullable)
	public orderByRecommendedCommunities?: boolean;

	@Transform(stringToBooleanNullable)
	public orderByNewInYourArea?: boolean;

	@Transform(stringToBooleanNullable)
	public orderByCommonInterests?: boolean;

	@Transform(stringToBooleanNullable)
	public onlyNotPrioritizedDiscoveryCommunityProfiles?: boolean;

	@Transform(jsonStringToObject)
	public orderedBy?: OrderParamPair<UserDto>[] | null;

	public orderedUsersIds?: string[];

	public stateIds?: string[];

	public cityIds?: string[];

	public interestIds?: string[];

	public adminId?: string;

	public communityProfileId?: string;

	@Transform(arrayOrStringToArray)
	public adminRoleIds?: CommunityProfileAdminsEnum[];

	public userIds?: string[];

	public userIdsToExclude?: string[];

	public search?: string;

	@Transform(stringToNumber)
	public threshold?: string;

	public profilePrivacy?: AccountsPrivacyOptionsEnum;

	public gendersIds?: GendersEnum[];

	public pageSize?: number | null;
	public page?: number | null;

	@Transform(stringToBoolean)
	public includeLeaderboard?: boolean;
}

export class OneUserFilters {
	@Transform(stringToBoolean)
	withAdmins?: boolean;

	@Transform(stringToBoolean)
	withFiles?: boolean;

	@Transform(stringToBoolean)
	withChallenges?: boolean;
	@Transform(stringToBoolean)
	withEventsCount?: boolean;

	@Transform(stringToBoolean)
	withFriendsAndFollowers?: boolean;

	@Transform(stringToBoolean)
	withConnectionFlags?: boolean;

	@Transform(stringToBoolean)
	withDeleted?: boolean;

	@Transform(stringToBoolean)
	withFriendsAndFollowersList?: boolean;

	@Transform(stringToBoolean)
	withFriendsAndFollowersCount?: boolean;
}
